<div class="selection-wrapper">
  <div @click="updateAddress('delivery_address')" class="selection-holder">
    <div class="text" :class="{'has-value': !showPlaceholder('delivery_address') , error: isShippingAddressInvalid || isShippingAddressRequired}">
      <div class="label">{{ $t('my_account.addresses.delivery_address') }}</div>
      <div class="value" v-if="!showPlaceholder('delivery_address')">{{ getAddressString('delivery_address') }}</div>
    </div>
    <div class="icon iconfont-triangle-right"></div>
  </div>
  <ul class="error-message">
    <li v-if="isShippingAddressInvalid" v-html="$t('shopping.errors.invalid_address')"></li>
    <li v-if="isShippingAddressRequired" v-html="$t('app.address.address_is_required')"></li>
    <li v-if="errors?.delivery_address?.generic">{{ errors.delivery_address.generic }}</li>
    <!-- <li v-if="!checkout.value.is_delivery_country_valid" v-html="$t('shopping.invalid_delivery_country')"></li> -->
  </ul>
</div>
<div class="toggle-holder" v-if="!hideInvoiceAddress">
  <NBToggle :label="$t('shopping.basket.checkout.billing_delivery_same')" v-model="isBillingAddressSame" />
</div>
<div class="selection-wrapper-invoice" v-if="!isBillingAddressSame && !hideInvoiceAddress">
  <div @click="updateAddress('invoice_address')" class="selection-holder">
    <div class="text" :class="{'has-value': !showPlaceholder('invoice_address'), error: isInvoiceAddressInvalid || isInvoiceAddressRequired}">
      <div class="label">{{ $t('my_account.addresses.invoice_address') }}</div>
      <div class="value" v-if="!showPlaceholder('invoice_address')">{{ getAddressString('invoice_address') || $t('my_account.addresses.invoice_address') }}</div>
    </div>
    <div class="icon iconfont-triangle-right"></div>
  </div>
  <div v-if="isInvoiceAddressInvalid" v-html="$t('shopping.errors.invalid_address')" class="error-message"></div>
  <div v-if="isInvoiceAddressRequired" v-html="$t('app.address.address_is_required')" class="error-message"></div>
</div>
